import { screenToRink } from './render';
import type { Role } from '../types';

export interface InputState {
  /** Latest pointer position in rink coordinates. */
  x: number;
  y: number;
  /** Monotonic input seq, useful for guest→host. */
  seq: number;
}

export function attachInput(
  canvas: HTMLCanvasElement,
  state: InputState,
  role: Role,
): () => void {
  const onPointer = (clientX: number, clientY: number) => {
    const r = screenToRink(canvas, clientX, clientY, role);
    state.x = r.x;
    state.y = r.y;
    state.seq++;
  };

  const onMouseMove = (e: MouseEvent) => onPointer(e.clientX, e.clientY);
  const onTouchMove = (e: TouchEvent) => {
    if (e.touches.length === 0) return;
    const t = e.touches[0]!;
    onPointer(t.clientX, t.clientY);
    e.preventDefault();
  };
  const onTouchStart = onTouchMove;

  canvas.addEventListener('mousemove', onMouseMove);
  canvas.addEventListener('touchmove', onTouchMove, { passive: false });
  canvas.addEventListener('touchstart', onTouchStart, { passive: false });

  return () => {
    canvas.removeEventListener('mousemove', onMouseMove);
    canvas.removeEventListener('touchmove', onTouchMove);
    canvas.removeEventListener('touchstart', onTouchStart);
  };
}
